<script setup lang="ts">
import { settings, PATHS } from '@/content'

defineProps<{ title?: string; subject?: string }>()
</script>

<template>
  <section class="section cta">
    <div class="container cta__in">
      <div class="cta__text">
        <h2>{{ title || 'Parlons de votre projet' }}</h2>
        <p>
          Vous avez un projet de menuiserie, d'agencement ou besoin d'une intervention rapide ?
          Nos équipes vous accompagnent des solutions sur mesure, adaptées à votre habitat et à vos
          contraintes.
        </p>
        <ul class="cta__phones">
          <li v-for="p in settings.phones" :key="p.tel">
            <a :href="`tel:${p.tel}`">
              <span class="ico" aria-hidden="true">✆</span>
              {{ p.display }} <span class="cta__city">({{ p.label }})</span>
            </a>
          </li>
          <li>
            <a :href="`mailto:${settings.email}`">
              <span class="ico" aria-hidden="true">✉</span> {{ settings.email }}
            </a>
          </li>
        </ul>
      </div>
      <div class="cta__action">
        <router-link :to="PATHS.contact" class="btn btn--primary btn--block">
          Demander une étude ou une intervention
        </router-link>
      </div>
    </div>
  </section>
</template>

<style scoped>
.cta {
  background: var(--bg-alt);
}
.cta__in {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 32px;
  align-items: center;
}
.cta__phones {
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
  display: grid;
  gap: 10px;
}
.cta__phones a {
  color: var(--title);
  font-weight: 700;
  font-size: 1.05rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.cta__phones a:hover {
  color: var(--green-dark);
  text-decoration: none;
}
.ico {
  color: var(--green);
}
.cta__city {
  color: var(--muted);
  font-weight: 400;
  font-size: 0.9rem;
}
@media (max-width: 760px) {
  .cta__in {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
